import { type ReactNode } from 'react';
import { IconClipboard } from './Icons';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '48px 24px',
        textAlign: 'center',
      }}
    >
      <div style={{ marginBottom: 16, color: 'var(--t3)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {icon || <IconClipboard size={40} strokeWidth={1.2} />}
      </div>
      <h3 style={{ fontSize: 16, fontWeight: 600, color: 'var(--t1)', margin: '0 0 6px' }}>
        {title}
      </h3>
      {description && (
        <p style={{ fontSize: 13, color: 'var(--t3)', margin: '0 0 20px', maxWidth: 360, lineHeight: 1.5 }}>
          {description}
        </p>
      )}
      {action}
    </div>
  );
}
